'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import t from "../defs/CaretRight.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...o, weights: t }));
e.displayName = "CaretRightIcon";
const s = e;
export {
  s as CaretRight,
  e as CaretRightIcon
};
